__turbopack_context__.v({
  "bazaarvoice-review-pagination": "bazaarvoice-review-pagination-component-module-scss-module__GlF_PW__bazaarvoice-review-pagination",
  "bazaarvoice-review-pagination__button": "bazaarvoice-review-pagination-component-module-scss-module__GlF_PW__bazaarvoice-review-pagination__button",
  "bazaarvoice-review-pagination__controls": "bazaarvoice-review-pagination-component-module-scss-module__GlF_PW__bazaarvoice-review-pagination__controls",
  "bazaarvoice-review-pagination__range": "bazaarvoice-review-pagination-component-module-scss-module__GlF_PW__bazaarvoice-review-pagination__range",
});
